import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { accessControl } from 'lib-shared-access-control';
import { ampli } from 'lib-shared-tracking';
import { PureComponent } from 'react';

import { IfFeatureFlagOn } from 'components/shared/featureFlag';

import styles from './automationDotsMenu.module.scss';

type PropsT = {
  automationId: string;
  showSettingsModal: (id: string) => void;
  gotoAutomationFlow: (id: string) => void;
  gotoAuditLogs: (id: string) => void;
  duplicateAutomation: (id: string) => void;
  deleteAutomation: (id: string) => void;
};

export class AutomationDotsMenu extends PureComponent<PropsT> {
  @boundMethod
  gotoAutomationFlow() {
    const { automationId, gotoAutomationFlow } = this.props;
    ampli.automationsOptionsMenuOptionFlowClicked();
    gotoAutomationFlow(automationId);
  }

  @boundMethod
  gotoAuditLogs() {
    const { automationId, gotoAuditLogs } = this.props;
    ampli.automationsFlowOptionsMenuOptionAuditLogClicked();
    gotoAuditLogs(automationId);
  }

  @boundMethod
  showSettingsModal() {
    const { automationId, showSettingsModal } = this.props;
    ampli.automationsOptionsMenuOptionSettingsClicked();
    showSettingsModal(automationId);
  }

  @boundMethod
  duplicateAutomation() {
    const { automationId, duplicateAutomation } = this.props;
    ampli.automationsOptionsMenuOptionDuplicateClicked();
    duplicateAutomation(automationId);
  }

  @boundMethod
  deleteAutomation() {
    const { automationId, deleteAutomation } = this.props;
    ampli.automationsOptionsMenuOptionDeleteClicked();
    deleteAutomation(automationId);
  }

  @boundMethod
  onToggleMenu(isOpen: boolean) {
    if (isOpen) {
      ampli.automationsOptionsMenuOpened();
    }
  }

  render() {
    const hasFlowWriteAccess = accessControl.hasAccess('settings.flow:w');

    return (
      <DropdownButton
        icon="dots-h"
        fixed
        buttonProps={{ variant: 'tertiary' }}
        noArrow
        onToggle={this.onToggleMenu}
        dropdown={
          <ButtonList className={styles.actionsList}>
            <ButtonList.Item onClick={this.gotoAutomationFlow}>
              Edit flow
            </ButtonList.Item>
            {hasFlowWriteAccess && (
              <>
                <ButtonList.Item onClick={this.showSettingsModal}>
                  Rename
                </ButtonList.Item>
                <ButtonList.Item onClick={this.duplicateAutomation}>
                  Duplicate
                </ButtonList.Item>
              </>
            )}
            <IfFeatureFlagOn name="routing-audit-log-automations">
              <ButtonList.Item onClick={this.gotoAuditLogs}>
                See audit log
              </ButtonList.Item>
            </IfFeatureFlagOn>
            {hasFlowWriteAccess && (
              <>
                <ButtonList.Divider />
                <ButtonList.Item
                  onClick={this.deleteAutomation}
                  buttonClassName={styles.delete}
                >
                  Delete
                </ButtonList.Item>
              </>
            )}
          </ButtonList>
        }
      />
    );
  }
}
